import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []
  
  constructor(context) {
    super(context);
  }
  
  connect() {
    if (this.element.hasAttribute('data-map-resizer-connected')) {
      return
    }
    
    this.isExpanded = false
    this.originalHeight = 530
    this.expandedHeight = 720
    
    this.element.setAttribute('data-map-resizer-connected', 'true')
    this.initialize()
  }

  initialize() {
    this.mapContainer = document.getElementById('map-container')
    this.mapTarget = document.querySelector('[data-monitoring-map-target="map"]')
    this.toggleButton = document.getElementById('toggle-panel')
    this.toggleText = document.getElementById('panel-toggle-text')
    this.toggleIcon = document.getElementById('panel-toggle-icon')
    
    if (this.mapContainer && this.mapTarget) {
      this.resetToInitialState()
    }
  }

  resetToInitialState() {
    this.applyHeight(this.originalHeight)
    this.isExpanded = false
    this.updateButtonState('Expandir', 'M19 9l-7 7-7-7')
  }

  applyHeight(height) {
    if (!height || isNaN(height)) {
      return
    }
    
    const heightPx = `${height}px`
    
    if (this.mapContainer) {
      this.mapContainer.classList.remove('h-64', 'h-48', 'h-56', 'h-72', 'h-80', 'h-96')
      this.mapContainer.style.setProperty('height', heightPx, 'important')
      this.mapContainer.style.setProperty('min-height', heightPx, 'important')
      this.mapContainer.style.setProperty('max-height', 'none', 'important')
    }
    
    if (this.mapTarget) {
      this.mapTarget.classList.remove('h-64', 'h-48', 'h-56', 'h-72', 'h-80', 'h-96')
      this.mapTarget.style.setProperty('height', heightPx, 'important')
      this.mapTarget.style.setProperty('min-height', heightPx, 'important')
      this.mapTarget.style.setProperty('max-height', 'none', 'important')
    }
    
    if (this.mapContainer) this.mapContainer.offsetHeight
    if (this.mapTarget) this.mapTarget.offsetHeight
    
    setTimeout(() => {
      try {
        if (window.google && window.google.maps && window.google.maps.event) {
          window.google.maps.event.trigger(window, 'resize')
        }
      } catch (error) {
        // Silent error handling
      }
    }, 100)
  }

  updateButtonState(text, iconPath) {
    if (this.toggleText) {
      this.toggleText.textContent = text
    }
    
    if (this.toggleIcon) {
      const pathElement = this.toggleIcon.querySelector('path')
      if (pathElement) {
        pathElement.setAttribute('d', iconPath)
      }
    }
  }

  toggleMapSize() {
    if (!this.mapContainer || !this.mapTarget) {
      this.mapContainer = document.getElementById('map-container')
      this.mapTarget = document.querySelector('[data-monitoring-map-target="map"]')
      
      if (!this.mapContainer || !this.mapTarget) {
        return
      }
    }

    if (this.isExpanded) {
      this.applyHeight(this.originalHeight)
      this.isExpanded = false
      this.updateButtonState('Expandir', 'M19 9l-7 7-7-7')
    } else {
      this.applyHeight(this.expandedHeight)
      this.isExpanded = true
      this.updateButtonState('Recolher', 'M5 15l7-7 7 7')
    }
  }

  disconnect() {
    this.element.removeAttribute('data-map-resizer-connected')
  }
}